<template>
    <div class="page-wrapper">
        <!-- 设备汇总全局loading -->
        <dv-loading v-if="loading" class="white-loading"
            style="position: fixed;top:0;left:0;width:100vw;height:100vh;z-index:9999;">
            Loading...
        </dv-loading>

        <div class="top-banner">
            <div class="top-image-wrapper">
                <img src="@/assets/orderSystem-top.png" alt="标题" class="top-image" />
                <div class="top-title">箱体设备状态</div>
            </div>

            <div class="stat-row">
                <div class="stat-item">总设备数：<span class="stat-value">110</span></div>
                <div class="stat-item">在线设备：<span class="stat-value">110</span></div>
                <div class="stat-item">满溢设备：<span class="stat-value">0</span></div>
            </div>
        </div>



        <div class="scroll-box-wrapper">
            <!-- ✅ border-box 应该包住整个内容 -->
            <dv-border-box-13 style="padding: 10px; overflow: hidden; position: relative;">
                <!-- 投递记录 loading 遮罩层 -->
                <div v-if="loadingDetail" class="loading-detail-overlay white-loading">
                    Loading 投递记录...
                </div>

                <!-- ✅ 整个表格放在这里面 -->
                <div class="table-container">
                    <table class="status-table">
                        <thead>
                            <tr>
                                <th>箱体名称</th>
                                <th>设备编号</th>
                                <th>投递记录</th>
                                <!-- <th>清运记录</th> -->
                                <th>所属商户</th>
                                <th>上次清运时间</th>
                                <th>满溢状态</th>
                                <th>状态</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in boxList">
                                <!-- 主表数据行 -->
                                <tr :key="'main-' + item.deviceId">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.deviceId }}</td>
                                    <td><button class="btn" @click="toggleDetail(index)">查看</button></td>
                                    <!-- <td><button class="btn">查看</button></td> -->
                                    <td>{{ item.company }}</td>
                                    <td>{{ item.lastClean }}</td>
                                    <td>
                                        <span :class="['tag', item.fullStatus === '未满溢' ? 'green' : 'red']">
                                            {{ item.fullStatus }}
                                        </span>
                                    </td>
                                    <td>
                                        <span :class="['tag', item.status === '正在使用' ? 'blue' : 'green']">
                                            {{ item.status }}
                                        </span>
                                    </td>
                                </tr>

                                <!-- 展开子表 -->
                                <tr v-if="activeIndex === index" :key="'detail-' + item.deviceId">
                                    <td colspan="8">
                                        <table class="sub-table">
                                            <thead>
                                                <tr>
                                                    <th>所属商户</th>
                                                    <th>昵称</th>
                                                    <th>手机号</th>
                                                    <th>垃圾类别</th>
                                                    <th>投递重量</th>
                                                    <th>实际重量</th>
                                                    <th>单价</th>
                                                    <th>金额</th>
                                                    <th>状态</th>
                                                    <th>箱体外照片</th>
                                                    <th>箱体内照片</th>
                                                    <th>投递时间</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(record, rIndex) in item.deliveryRecords" :key="rIndex">
                                                    <td>{{ record.cho1 }}</td>
                                                    <td>{{ record.cho2 }}</td>
                                                    <td>{{ record.cho3 }}</td>
                                                    <td>{{ record.cho6 }}</td>
                                                    <td>{{ record.cho7 }}</td>
                                                    <td>{{ record.cho8 }}</td>
                                                    <td>{{ record.cho9 }}</td>
                                                    <td>{{ record.cho10 }}</td>
                                                    <td>{{ record.cho11 }}</td>
                                                    <td>
                                                        <img v-if="record.cho12" :src="record.cho12" class="thumb-img"
                                                            @click="showImage(record.cho12)" />
                                                    </td>
                                                    <td>
                                                        <img v-if="record.cho13" :src="record.cho13" class="thumb-img"
                                                            @click="showImage(record.cho13)" />
                                                    </td>
                                                    <td>{{ record.cho14 }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </dv-border-box-13>
        </div>

        <!-- 放大图片展示 -->
        <div v-if="showImgUrl" class="img-dialog" @click="showImgUrl = ''">
            <img :src="showImgUrl" class="big-img" />
        </div>
    </div>
</template>

<script>
import { request } from '@/utils/request';

export default {
    data() {
        return {
            activeIndex: null,
            showImgUrl: '',
            boxList: [],
            loading: false,
            loadingDetail: false
        };
    },
    created() {
        this.fetchDeviceSummary();
    },
    methods: {
        fetchDeviceSummary() {
            this.loading = true;
            request({
                url: '/device/summary',
                method: 'get'
            })
                .then(res => {
                    if (res.data.code === 200) {
                        this.boxList = (res.data.data.devices || []).map(item => ({
                            name: item.device_name,
                            deviceId: item.device_code,
                            company: '润景',
                            lastClean: item.latest_deliver_time || '',
                            fullStatus: item.fullStatus || '未满溢',
                            status: item.status === '1' ? '正在使用' : '在线',
                            deliveryRecords: []
                        }));
                    } else {
                        console.error('设备汇总接口返回异常', res.data.msg);
                    }
                })
                .catch(err => {
                    console.error('获取设备状态失败', err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        toggleDetail(idx) {
            if (this.activeIndex === idx) {
                this.activeIndex = null;
                return;
            }
            this.loadingDetail = true;
            const deviceCode = this.boxList[idx].deviceId;

            request({
                url: '/order/list_by_device',
                method: 'get',
                params: {
                    device_code: deviceCode,
                    page: 1,
                    page_size: 10
                }
            })
                .then(res => {
                    if (res.data.code === 200) {
                        const typeMap = {
                            4149: '衣物',
                            4152: '废纸',
                            4153: '金属',
                            4154: '塑料'
                        };
                        const statusMap = {
                            0: '待审核',
                            1: '已结算',
                            2: '异常'
                        };

                        this.boxList[idx].deliveryRecords = (res.data.data.list || []).map(record => ({
                            cho1: '润景',
                            cho2: record.user_id,
                            cho3: this.maskPhone(record.phone),
                            cho5: record.device_name || '-',
                            cho6: typeMap[record.type] || '-',
                            cho7: record.check_weight + 'kg',
                            cho8: record.weight ? record.weight + 'kg' : '',
                            cho9: record.univalence ? record.univalence + '元' : '',
                            cho10: record.price ? record.price + '元' : '',
                            cho11: statusMap[record.status] || '-',
                            cho12: record.deliver_outside_img,
                            cho13: record.deliver_inside_img,
                            cho14: record.create_time
                        }));

                        this.activeIndex = idx;
                    } else {
                        console.error('投递记录接口返回错误', res.data.msg || res.data.data.msg);
                    }
                })
                .catch(err => {
                    console.error('请求投递记录失败', err);
                })
                .finally(() => {
                    this.loadingDetail = false;
                });
        },
        maskPhone(phone) {
            if (!phone) return '';
            return phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
        },
        showImage(url) {
            this.showImgUrl = url;
        }
    }
};
</script>

<style scoped>
.page-wrapper {
    width: 100vw;
    height: 100vh;
    background-image: url('@/assets/deviceInfo-bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    padding: 20px;
    box-sizing: border-box;
}

.scroll-box-wrapper {
    width: 1200px;
    /* height: 80vh; */
    height: auto;
    margin: 0 auto;
    color: #fff;
}

.table-container {
    max-height: calc(80vh - 100px);
    overflow-y: auto;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;
}

.table-container::-webkit-scrollbar {
    display: none;
}

.status-table {
    width: 100%;
    min-width: 1000px;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: auto;
    text-align: center;
    font-size: 16px;
    box-sizing: border-box;
    color: #fff;
}

.status-table th,
.status-table td {
    border: 1px solid #00baff;
    padding: 10px;
    height: 42px;
    box-sizing: border-box;
}

.status-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #012d46;
    border-top: 1px solid #00baff !important;
    border-bottom: 1px solid #00baff !important;
}

.status-table tbody tr:last-child td {
    border-bottom: 1px solid #00baff;
}

.btn {
    padding: 4px 8px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.btn:hover {
    background-color: #0056b3;
}

.tag {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
}

.tag.green {
    background-color: #28a745;
    color: white;
}

.tag.red {
    background-color: #dc3545;
    color: white;
}

.tag.blue {
    background-color: #007bff;
    color: white;
}

.sub-table {
    width: 100%;
    border: 1px solid #00baff;
    color: #fff;
    font-size: 14px;
    margin-top: 10px;
    border-collapse: collapse;
    text-align: center;
}

.sub-table th,
.sub-table td {
    border: 1px solid #00baff;
    padding: 8px;
}

.sub-table th {
    background-color: #012d46;
}

.top-banner {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
    position: relative;
}

.top-image-wrapper {
    position: relative;
    display: inline-block;
}

.top-image {
    max-width: 100%;
    height: auto;
    display: block;
}

.top-title {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 28px;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.thumb-img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    cursor: pointer;
}

.img-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.big-img {
    max-width: 90vw;
    max-height: 90vh;
    border: 4px solid white;
    border-radius: 8px;
}

.loading-detail-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 6px 0;
    background: rgba(0, 0, 0, 0.5);
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    z-index: 10;
    user-select: none;
}

/* ✅ 白色字体 Loading 样式 */
.white-loading {
    color: white !important;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
}

/* ✅ 标题下三项统计样式 */
.stat-row {
    display: flex;
    justify-content: center;
    gap: 60px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.stat-item {
    font-size: 20px;
    color: white;
    font-weight: bold;
}

.stat-value {
    margin-left: 6px;
    font-size: 22px;
    color: #00ffff;
}

.scroll-box-wrapper {
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    /* 自动高度，不留空 */
    height: auto;
}

.table-container {
    overflow-x: auto;
    max-height: calc(100vh - 250px);
    /* 留出头部空间 */
}
</style>
